// export const host = 'http://101.43.118.208:8000/user/subscribe'
export const host = 'http://10.10.3.118:8080'
import newsApi from './news';
import searchApi from './search';

export default {
    newsApi,searchApi
}